import { useGetFavoritedSoundPackages } from '@bpm-web-app/swr-hooks/src/hooks/create/sound-package';
import { convertSoundPackageToSeeMoreLayoutProps, createAppRoutes } from '@bpm-web-app/utils';
import { ClickableGenres } from '../clickable-genres/clickable-genres';
import SeeMoreLayout from '../see-more-layout/see-more-layout';

export function FavoritePacks() {
    const { data: favoritesSoundPacks } = useGetFavoritedSoundPackages();

    return (
        <SeeMoreLayout
            contentType="pack"
            pageTitle="Packs"
            count={favoritesSoundPacks?.pagination?.total || 0}
            itemBasePath={createAppRoutes.packs}
            data={favoritesSoundPacks?.data?.map((item) => convertSoundPackageToSeeMoreLayoutProps(item, <ClickableGenres genres={item.Genre} />)) ?? []}
        />
    );
}
export default FavoritePacks;
